import { render, staticRenderFns } from "./TestScreeningUnUpdate.vue?vue&type=template&id=75e7a12c&scoped=true&"
import script from "./TestScreeningUnUpdate.vue?vue&type=script&lang=js&"
export * from "./TestScreeningUnUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TestScreeningUnUpdate.vue?vue&type=style&index=0&id=75e7a12c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e7a12c",
  null
  
)

export default component.exports